import request from '@/api/request'

// 获取公共字典
export const getAllByKey = function (data) {
    return request({
        url: 'busDict/getDictsByKey',
        method: 'post',
        data
    })
}